// import { UserContext } from './Components/UserContext'
// const token = useContext(UserContext)
// const urlBase = 'https://api.spotify.com/v1/';

const requests = {
    getFeaturedPlaylists : async (token) => {
        const response = await fetch(`https://api.spotify.com/v1/browse/featured-playlists?limit=12`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        })
        return response.json();
    },
    getNewReleases : async (token) => {
        const response = await fetch(`https://api.spotify.com/v1/browse/new-releases?limit=10`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        })
        return response.json();
    },
    getCategories : async (token) => {
        const response = await fetch(`https://api.spotify.com/v1/browse/categories?limit=10`, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        })
        return response.json();
    },
    // getProfile : async (token) => {
    //     const response = await fetch(`https://api.spotify.com/v1/me`, {
    //         method: 'GET',
    //         headers: {
    //             'Accept': 'application/json',
    //             'Content-Type': 'application/json',
    //             'Authorization': 'Bearer ' + token
    //         }
    //     })
    //     return response.json();
    // }
}

export default requests;